(ns dre.i18n.db)


(def init-db
  {:messages {}
   :language nil})
